import { isEmptyString } from '@/utils/string';
import { useLocation } from 'react-router-dom';

const WORKSPACE_ID_URL_REGEX = /\/workspaces\/(\d*)(\/?|\/.*)$/;

export function getWorkspaceIdFromUrl(path: string) {
  const result = path.match(WORKSPACE_ID_URL_REGEX);
  if (result != null && result.length > 2) {
    const match = result[1];

    if (isEmptyString(match)) {
      return null;
    }

    return match;
  }
  return null;
}

export function getWorkspaceIdFromCurrentUrl(currentUrl = window.location.href): number | null {
  const workspaceIdString = getWorkspaceIdFromUrl(currentUrl);
  const workspaceId = Number(workspaceIdString);
  // Preserve the null to support possible downstream error checks
  return workspaceIdString !== null && !Number.isNaN(workspaceId) ? workspaceId : null;
}

export function useWorkspaceIdFromCurrentUrl(): number | null {
  const location = useLocation();
  return getWorkspaceIdFromCurrentUrl(location.pathname);
}
